import { makeStyles } from '@mui/styles';
import TextField from 'apollo-react/components/TextField';
import Typography from 'apollo-react/components/Typography';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useTranslation } from '../../custom-hooks/useTranslation';
import { editSavedSearch, validateSavedSearch } from '../actions/editor.actions';
import { getErrorByProp } from '../selectors/editor.selectors';

const useStyles = makeStyles({
  row: {
    display: 'flex',
    width: '100%',
    '@media (max-width: 480px)': {
      flexDirection: 'column',
    },
  },
  rowLabel: {
    width: 200,
    paddingTop: 8,
    marginRight: 20,
    alignItems: 'center',
  },
  rowControl: {
    flex: 1,
    minWidth: 300,
    alignItems: 'center',
    '& div': {
      margin: 0,
    },
    '@media (max-width: 480px)': {
      paddingTop: 8,
    },
    "& label[class*='MuiInputLabel-root'] span[class*='MuiFormLabel-asterisk']": {
      top: '3px !important',
      left: '-15px !important',
    },
  },
});

const TextBoxControl = ({
  prop,
  label,
  currentValue,
  required = false,
  editAction = editSavedSearch,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const translateString = useTranslation();
  const error = useSelector((state) => getErrorByProp(state, { prop }));
  const [value, setValue] = useState(currentValue);

  useEffect(() => {
    setValue(currentValue);
  }, [currentValue]);

  const handleBlur = ({ target: { value: v } }) => {
    const _value = v.trim();

    if (_value === currentValue) {
      return;
    }

    dispatch(editAction({ prop, value: _value }));
    error && dispatch(validateSavedSearch());
  };

  return (
    <div className={classes.row}>
      <div className={classes.rowLabel}>
        <Typography>{translateString(label)}</Typography>
      </div>
      <div className={classes.rowControl}>
        <TextField
          fullWidth
          asteriskPosition="before"
          required={required}
          value={value ?? ''}
          onChange={({ target }) => setValue(target.value)}
          onBlur={handleBlur}
          error={!!error}
          helperText={error ? error.message : null}
          inputProps={{
            'aria-label': translateString(label),
          }}
        />
      </div>
    </div>
  );
};

export default TextBoxControl;
